import getSignalDelayData from './helper/SignalDelayResultHelper';

export default function getSignalDelay({ skewSpec, verificationSubId, channelId, interfaceName, verificationId }) {
  return getSignalDelayData({ skewSpec, verificationSubId, channelId, interfaceName, verificationId });
};